import { nsModel } from "../../../../../lib/namespace";

export const cardNetworkNS = nsModel("cardNetwork");
